var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7299 17.9983L13.7299 3.99827C13.5555 3.69048 13.3025 3.43446 12.9969 3.25634C12.6912 3.07822 12.3437 2.98437 11.9899 2.98438C11.6361 2.98437 11.2887 3.07822 10.983 3.25634C10.6773 3.43446 10.4244 3.69048 10.2499 3.99827L2.24993 17.9983C2.07361 18.3036 1.98116 18.6502 1.98194 19.0028C1.98272 19.3554 2.07671 19.7015 2.25438 20.0061C2.43204 20.3107 2.68708 20.5629 2.99362 20.7371C3.30017 20.9113 3.64734 21.0014 3.99993 20.9983H19.9999C20.3508 20.9979 20.6955 20.9052 20.9992 20.7296C21.303 20.5539 21.5551 20.3014 21.7304 19.9974C21.9057 19.6934 21.998 19.3487 21.9979 18.9978C21.9978 18.6469 21.9054 18.3022 21.7299 17.9983Z",
    stroke: "#FF9345",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#FF9345",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.0083",
    stroke: "#FF9345",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSubmit);
export default __webpack_public_path__ + "static/media/AlertSubmit.c5498e5b4af17b31f7ca56721b15e17f.svg";
export { ForwardRef as ReactComponent };